import * as React from "react";
const SvgEdit20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M19.414 6 14 .586 1.545 13.04l-.677 6.091 6.091-.677L19.414 6ZM3.132 16.868l.323-2.909 7.795-7.795 2.586 2.586-7.795 7.795-2.909.323ZM15.25 7.336 16.586 6 14 3.414 12.664 4.75l2.586 2.586Z",
      clipRule: "evenodd"
    })
  );
export default SvgEdit20Px;
